
import Vue from 'vue'
import Button from '@/components/Button.vue'

export default Vue.extend({
	name: 'AppModal',
	components: {
		Button
	},
	props: {
		value: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ''
		},
		showClose: {
			type: Boolean,
			default: true
		},
		maxWidth: {
			type: [String, Number],
			default: 560
		},
		persistent: {
			type: Boolean,
			default: true
		},
		cancelText: {
			type: String,
			default: ''
		},
		confirmText: {
			type: String,
			default: ''
		},
		confirmDisabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		close() {
			this.$emit('input', false)
			this.$emit('close')
		},
		onCancel() {
			this.$emit('cancel')
			this.close()
		},
		onConfirm() {
			this.$emit('confirm')
		}
	}
})
